var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-pin-empty",
  "use": "ring-icon-pin-empty-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-pin-empty\"><path d=\"M15.68 5.838L10.257.418l-.92.92.53.53-3.31 3.31H3.729L2.315 6.594 5.4 9.678 1.157 13.92l.843.843 4.243-4.242 3.143 3.143L10.8 12.25V9.422l3.312-3.312.647.648zM9.951 8.573l-.352.351v2.829l-.214.214-5.374-5.374.214-.214h2.829l.351-.352 3.311-3.31 2.546 2.545z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id